import { Icon, Menu, TopBar, TopBarProfileButton, TopBarSeparator } from '@nordlayer/rivendell-ui';
import { RegionSwitcher } from 'shared/components/RegionSwitcher';
import { Features } from '../../../types/features/enums';
import { useFeatureFlag } from '../../../utils/useFeatureFlag';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var Header = function Header(_ref) {
    var currentAccount = _ref.currentAccount;
    var isRegionSwitcherEnabled = useFeatureFlag(Features.MultiRegionSwitcher);
    return /*#__PURE__*/ _jsxs(TopBar, {
        children: [isRegionSwitcherEnabled && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [/*#__PURE__*/ _jsx(RegionSwitcher, {}), /*#__PURE__*/ _jsx(TopBarSeparator, {})]
            }), /*#__PURE__*/ _jsxs(Menu, {
                children: [/*#__PURE__*/ _jsx(TopBarProfileButton, {
                        fullName: (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.name) || '',
                        userRole: null
                    }), /*#__PURE__*/ _jsx(Menu.Popover, {
                        placement: "bottom",
                        children: /*#__PURE__*/ _jsx(Menu.Content, {
                            children: /*#__PURE__*/ _jsxs(Menu.Item, {
                                href: "/logout",
                                children: [/*#__PURE__*/ _jsx(Icon, {
                                        name: "logout16"
                                    }), "Log out"]
                            })
                        })
                    })]
            })]
    });
};
